import UpcomingDishes from "./UpcomingDishes";

export default UpcomingDishes;
